import React from "react";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import useGetOneData from "../../hooks/useGetOneData";
import { MdClose } from "react-icons/md";

type IViewApplication = {
    id: number | undefined
    isOpen: boolean,
    setisOpen: any
}

const ViewApplication: React.FC<IViewApplication> = ({ id, isOpen, setisOpen }) => {
    const { t } = useTranslation()

    const { data } = useGetOneData<any>({
        queryKey: ["online_application_users", id],
        url: `online_application_users/${id}`,
        options: {
            enabled: !!id
        }
    })

    return (
        <>
            <Drawer
                closable={false}
                title={<div className="flex justify-between items-center"><p>{data?.title ? data?.title : t('View')}</p><MdClose size={18} className="hover:cursor-pointer" onClick={() => setisOpen(false)}/></div>}
                placement="right"
                open={isOpen}
                onClose={() => setisOpen(false)}
            >
                <h3>{t("Application name")} : {data?.title}</h3>
                <h3>{t("Description")} : {data?.description}</h3>
            </Drawer>
        </>
    )
}

export default ViewApplication